module.exports = __webpack_public_path__ + "static/media/plus-down.807bd93f.svg";